import { TrashIcon } from '@setvi/shared/components/sicons';
import { IconContainer } from './styled';
import { CancelConfirmation } from '../../../cancel-confirmation';

interface MobileClearSelectedProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const MobileClearSelected = ({
  onCancel,
  onConfirm
}: MobileClearSelectedProps) => (
  <CancelConfirmation
    icon={
      <IconContainer>
        <TrashIcon fontSize="small" htmlColor="#fff" />
      </IconContainer>
    }
    title="Are you sure you want to clear all product selection?"
    description="This action will remove all your selection."
    confirmText="Clear All"
    onConfirm={onConfirm}
    onCancel={onCancel}
  />
);
